import { type BlockConfiguration } from '@/types/blocks';
import clsx from 'clsx';

export const Block: React.FC<{
  block: BlockConfiguration;
  compact?: boolean;
}> = ({ block, compact = false }) => {
  return (
    <div
      className={clsx(
        'block',
        compact ? 'size-full' : 'size-[50px]',
        'bg-gray-300',
      )}
    >
      <div
        className={clsx(
          'size-full',
          {
            'bg-black': block.color === 'black',
            // 'bg-white': block.color === 'white',
            'bg-accent-yelo': block.color === 'yellow',
            'bg-accent-oranje': block.color === 'orange',
            // 'bg-accent-grun': block.color === 'green',
            'bg-accent-blau': block.color === 'blue',
          },
          {
            'rounded-none': block.shape.shape === 'square',
            'rounded-full': block.shape.shape === 'circle',
            'rounded-tl-full':
              block.shape.shape === 'quarter-circle' &&
              block.shape.orientation === 'top-left',
            'rounded-tr-full':
              block.shape.shape === 'quarter-circle' &&
              block.shape.orientation === 'top-right',
            'rounded-bl-full':
              block.shape.shape === 'quarter-circle' &&
              block.shape.orientation === 'bottom-left',
            'rounded-br-full':
              block.shape.shape === 'quarter-circle' &&
              block.shape.orientation === 'bottom-right',
          },
        )}
      />
    </div>
  );
};
